"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const type_graphql_1 = require("type-graphql");
const User_1 = require("./User");
const Workspace_1 = require("./Workspace");
const graphql_1 = require("../../graphql");
let Session = class Session {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => Number),
    typeorm_1.Index(),
    typeorm_1.Column('bigint'),
    tslib_1.__metadata("design:type", Number)
], Session.prototype, "expiredAt", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID),
    typeorm_1.PrimaryColumn('varchar', { length: 255 }),
    tslib_1.__metadata("design:type", String)
], Session.prototype, "id", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => graphql_1.GraphQLJSON),
    typeorm_1.Column('text'),
    tslib_1.__metadata("design:type", String)
], Session.prototype, "json", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => User_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", User_1.User)
], Session.prototype, "user", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace, { nullable: true }),
    tslib_1.__metadata("design:type", Workspace_1.Workspace)
], Session.prototype, "workspace", void 0);
Session = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], Session);
exports.Session = Session;
class SessionEntity extends Session {
    toString() {
        return `Session #${this.id}`;
    }
}
exports.SessionEntity = SessionEntity;
//# sourceMappingURL=Session.js.map